import {ButtonPriority} from 'wix-ui-tpa';
import {Button} from 'wix-ui-tpa/cssVars';
import React from 'react';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import {classes} from './CartButton.st.css';
import {settingsParams} from '../../../settingsParams';
import classNames from 'clsx';
import {useSettingsWithDefaults} from '../../../../../hooks/useSettingsWithDefaults';

export enum CartButtonDataHooks {
  root = 'CartButtonDataHooks.root',
}

export interface CartButtonProps {
  className?: string;
}

export const CartButton = ({className}: CartButtonProps) => {
  const {getSettingsWithDefaults} = useSettingsWithDefaults();
  const {navigateToCart} = useControllerProps().navigationStore;

  return (
    <Button
      className={classNames(classes.button, className)}
      data-hook={CartButtonDataHooks.root}
      priority={ButtonPriority.basicSecondary}
      onClick={() => navigateToCart()}
      upgrade
      fullWidth>
      {getSettingsWithDefaults(settingsParams.SIDE_CART_CART_BUTTON)}
    </Button>
  );
};
